import link from "./link";
import folder from "./folder";
import page from "./page";
import pageList from "./pageList";

export default [link, folder, page, pageList];
